import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { YouzuSwapStats } from "@/components/youzu-swap/youzu-swap-stats";
import { FeatureChart } from "@/components/feature-chart";
import { RoomVisualizerPopular } from "@/components/room-visualizer/room-visualizer-popular";
import { YouzuSwapSDK } from "@/components/youzu-swap/youzu-swap-sdk";
import { Activities } from "@/components/activities";
import { GenerationsList } from "@/components/generations-list";
import { CatalogueSelector } from "@/components/catalogue-selector";

const YouzuSwapPage: React.FC = () => {
  const [selectedCatalogueId, setSelectedCatalogueId] = useState<string>("");

  return (
    <>
      <main className="flex-1 space-y-6 p-2">
        <div className="space-y-2">
          <h2 className="text-3xl font-bold tracking-tight bg-gradient-to-r from-pink-500 to-purple-500 bg-clip-text text-transparent">
            Youzu Swap
          </h2>
          <p className="text-muted-foreground">
            Swap and replace items in room scenes with AI
          </p>
        </div>

        <Tabs defaultValue="overview" className="space-y-6">
           <TabsList>
             <TabsTrigger value="overview">Overview</TabsTrigger>
             <TabsTrigger value="generations">Generations</TabsTrigger>
             <TabsTrigger value="analytics">Analytics</TabsTrigger>
             <TabsTrigger value="playground">Playground</TabsTrigger>
           </TabsList>

          <TabsContent value="overview" className="space-y-6">
            <YouzuSwapStats />

            <Card>
              <CardHeader>
                <CardTitle>Swap Trends</CardTitle>
                <CardDescription>Swaps performed over time</CardDescription>
              </CardHeader>
              <CardContent>
                <FeatureChart
                  featureKey="swap"
                  usersKey="swapUsers"
                  dataLabel="Swaps"
                  color="#9D4EDD"
                  showUsers={true}
                />
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Popular Swaps</CardTitle>
                <CardDescription>
                  Most frequent item replacements
                </CardDescription>
              </CardHeader>
              <CardContent>
                <RoomVisualizerPopular />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="analytics" className="space-y-6">
            <Card>
              <CardHeader>
                <CardTitle>Swap Trends</CardTitle>
                <CardDescription>Swaps performed over time</CardDescription>
              </CardHeader>
              <CardContent>
                <FeatureChart
                  featureKey="swap"
                  usersKey="swapUsers"
                  dataLabel="Swaps"
                  color="#9D4EDD"
                  showUsers={true}
                />
              </CardContent>
            </Card>

            <Activities
              filterEventType="SWAP_CREATE"
              title="Youzu Swap Analytics"
              description="Event history and analytics"
            />
           </TabsContent>

           <TabsContent value="generations" className="space-y-6">
             <GenerationsList type="swap" />
           </TabsContent>

           <TabsContent value="playground" className="space-y-6">
            <Card>
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <div>
                  <CardTitle>Swap Demo</CardTitle>
                  <CardDescription>
                    Interactive playground to preview swap interactions
                  </CardDescription>
                </div>
                <CatalogueSelector
                  value={selectedCatalogueId}
                  onValueChange={setSelectedCatalogueId}
                />
              </CardHeader>
              <CardContent className="p-0">
                <YouzuSwapSDK catalogueId={selectedCatalogueId} />
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </main>
    </>
  );
};

export default YouzuSwapPage;
